import { useContext } from 'react';
import {
  RoomStateContext,
  RoomStateContextType,
} from '../contexts/RoomStateContext';

/**
 * Hook to access the full room context.
 * Provides access to room state and all room-related actions.
 *
 * @throws {Error} If used outside of RoomProvider
 * @returns The complete room context value
 */
export function useRoomState(): RoomStateContextType {
  const context = useContext(RoomStateContext);
  if (!context) {
    throw new Error('useRoomState must be used within a RoomStateProvider');
  }
  return context;
}
